import { HttpMethod, RequestOptions } from "../common/lib/fetch";
import useUserOrKioskRequest from "../common/lib/fetch/useUserOrKioskRequest";
import { StagedPurchaseOrder } from "../pages/StageOrderFlow/StageOrderTypes";

export interface CreateStagedPurchaseOrder {
  carrierNumber?: string,
  transportNumber?: string,
  driverNumber?: string,
  driverPassword?: string,
  purchaseOrderNumber: string,
  kioskId?: string,
}

const useCreateStagedPurchaseOrder = (siteId: string, options: RequestOptions<StagedPurchaseOrder>) =>
  useUserOrKioskRequest<CreateStagedPurchaseOrder, StagedPurchaseOrder>({
    path: `/api/sites/${siteId}/stagedPurchaseOrders`,
    method: HttpMethod.POST
  }, options);

export default useCreateStagedPurchaseOrder;